import { NgModule } from '@angular/core';
import { FiOpenChecklistsReportComponent } from './open-checklists-report.component';
import { FiOpenChecklistsSummaryTableWrapperComponent } from '@fi-shared/checklist/fi-checklist2-report/components/open-checklists-report/open-checklists-summary-table-wrapper/open-checklists-summary-table-wrapper.component';
import { FiOpenChecklistsSummaryTableComponent } from '../../components/open-checklists-report/open-checklists-summary-table-wrapper/open-checklists-summary-table/open-checklists-summary-table.component';
import { FiOpenChecklistsChartComponent } from './open-checklists-chart/open-checklists-chart.component';
import { FiOpenChecklistsWidgetComponent } from '../../components/open-checklists-report/open-checklists-widget/open-checklists-widget.component';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiChecklist2ListModule } from '@fi-shared/checklist/fi-checklist2-list/fi-checklist2-list.module';
import { FiLocalSearch2Module } from '@fi-shared/fi-local-search2/fi-local-search2.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { FiWrapperTableModule } from '@fi-shared/fi-wrapper-table/fi-wrapper-table.module';
import { InfoIconModule } from '@fi-shared/info-icon/info-icon.module';
import { FiOpenChecklistDetailsComponent } from '@fi-shared/checklist/fi-checklist2-report/components/open-checklists-report/open-checklist-details/open-checklist-details.component';
import { FiChecklistUnitAnswerDetailsDialogComponent } from '@fi-shared/checklist/fi-checklist2-report/components/open-checklists-report/checklist-unit-answers-details-dialog/checklist-unit-answers-details-dialog.component';
import { FiChecklistDetailsTabGroupComponent } from '../../components/open-checklists-report/open-checklist-details/checklist-details-tab-group/checklist-details-tab-group.component';
import { FiChecklistDetailsUnitsTableComponent } from '@fi-shared/checklist/fi-checklist2-report/components/open-checklists-report/open-checklist-details/checklist-details-tab-group/checklist-details-units-table/checklist-details-units-table.component';
import { FiChecklistDetailsCheckpointsTableComponent } from '../../components/open-checklists-report/open-checklist-details/checklist-details-tab-group/checklist-details-checkpoints-table/checklist-details-checkpoints-table.component';
import { CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatButtonModule } from '@angular/material/button';
import { FiPageHeaderModule } from '@fi-app/components/fi-page-header/fi-page-header.module';
import { FiTwoColumnsContainerModule } from '@fi-shared/fi-two-columns-container/fi-two-columns-container.module';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiChecklist2ReportSharedModule } from '@fi-shared/checklist/fi-checklist2-report/components/shared/checklist-report-shared.module';
import { FiChecklist2ListColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-list-column-defs/fi-checklist2-list-column-defs.module';
import { FiChecklist2ReportColumnDefsModule } from '@fi-shared/checklist/fi-checklist2-report/fi-checklist2-report-column-defs/fi-checklist2-report-column-defs.module';
import { FiRollupContentModule } from '@fi-shared/rollup/rollup-content.module';
import { FiOpenChecklistsDeviationsChart } from '@fi-shared/checklist/fi-checklist2-report/components/open-checklists-report/open-checklist-deviations-cart/open-checklist-deviations-chart.component';
import { FiIconTooltipButtonModule } from '@fi-shared/fi-icon-tooltip-button/fi-icon-tooltip-button.module';
import { FiReportWidgetModule } from '@fi-shared/fi-report-widget/fi-report-widget.module';
import { FiReportPieChartModule } from '@fi-shared/fi-report-pie-chart/fi-report-pie-chart.module';

@NgModule({
    imports: [
        CommonModule,
        FiAppTextSharedModule,
        MatCardModule,
        FiWrapperTableModule,
        InfoIconModule,
        MatIconModule,
        FiChecklist2ReportSharedModule,
        FiAttachmentsModule,
        FiFormatDateModule,
        FiChecklist2ListModule,
        FiLocalSearch2Module,
        CdkDragHandle,
        MatButtonModule,
        FiPageHeaderModule,
        FiTwoColumnsContainerModule,
        FiProfileIconModule,
        FiChecklist2ListColumnDefsModule,
        FiChecklist2ReportColumnDefsModule,
        FiRollupContentModule,
        FiIconTooltipButtonModule,
        FiReportWidgetModule,
        FiReportPieChartModule,
    ],
    declarations: [
        FiOpenChecklistsReportComponent,
        FiOpenChecklistsSummaryTableWrapperComponent,
        FiOpenChecklistsSummaryTableComponent,
        FiOpenChecklistsChartComponent,
        FiOpenChecklistsWidgetComponent,
        FiOpenChecklistDetailsComponent,
        FiChecklistUnitAnswerDetailsDialogComponent,
        FiChecklistDetailsTabGroupComponent,
        FiChecklistDetailsUnitsTableComponent,
        FiChecklistDetailsCheckpointsTableComponent,
        FiOpenChecklistsDeviationsChart,
    ],
    exports: [
        FiOpenChecklistDetailsComponent,
        FiOpenChecklistsWidgetComponent,
        FiOpenChecklistsReportComponent,
        FiOpenChecklistsSummaryTableWrapperComponent,
    ],
})
export class FiChecklist2ReportOpenChecklistModule {}
